export default "__VITE_PUBLIC_ASSET__ba20d9b2__"